import { Button, Card, Text } from '@mercai/clever'

import { HeaderProps } from './header.type'

import styles from './header.module.css'

export const Header = ({
  description,
  title,
  buttonAiPaused,
  isAiPaused,
  isAiPausing,
  onToggleAiPaused,
}: HeaderProps) => {
  return (
    <Card className={styles.core}>
      <Text variant="title-large" className={styles.title}>
        {title}
      </Text>

      <div className={styles.content}>
        <Text className={styles.description}>{description}</Text>

        {isAiPaused && (
          <Button
            onClick={onToggleAiPaused}
            variant="light"
            size="xsmall"
            isLoading={isAiPausing}
          >
            {buttonAiPaused}
          </Button>
        )}
      </div>
    </Card>
  )
}
